import React from "react"
import { flowRight as compose } from "lodash"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { Card, CardBody } from "reactstrap"
import ReactTable from "react-table"
import moment from "moment"
import { Link } from "react-router-dom"
import { useQuery } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import withModal from "components/modal"
import { orderStatusTypes, findTypeValueByKey } from "utils/types"
import { GET_ORDERS } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const OrderAuditClListContainer = props => {
  const { data, loading } = useQuery(GET_ORDERS, {
    fetchPolicy: "cache-and-network"
  })

  useBread({ to: props.match.url, name: "審核訂單" }, true)

  const fieldsDefinition = props => {
    return [
      {
        Header: "id",
        accessor: "id",
        show: false
      },
      {
        id: "orderNumber",
        Header: "巨研訂單編號",
        style: columStyle,
        width: 150,
        accessor: data => data.orderNumber,
        Cell: cell => {
          return (
            <Link to={`${props.match.url}/detail/${cell.row.id}`}>
              {cell.row.orderNumber || "未成立之訂單"}
            </Link>
          )
        }
      },
      {
        id: "orderStatus",
        Header: "訂單狀態",
        style: columStyle,
        accessor: data => findTypeValueByKey(orderStatusTypes, data.status),
        Cell: cell => {
          return <div>{cell.row.orderStatus}</div>
        }
      },
      {
        id: "companyName",
        Header: "公司名稱",
        style: columStyle,
        accessor: data => data.company?.name,
        Cell: cell => {
          return <div>{cell.row.companyName}</div>
        }
      },
      {
        id: "user",
        Header: "建立者",
        style: columStyle,
        accessor: data => data.user?.name,
        Cell: cell => {
          return <div>{cell.row.user}</div>
        }
      },
      {
        id: "updatedAt",
        Header: "最後更新時間",
        style: columStyle,
        accessor: data => moment(data.updatedAt).format("YYYY-MM-DD a h:mm"),
        Cell: cell => {
          return <div>{cell.row.updatedAt}</div>
        }
      }
    ]
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Card>
        <CardBody>
          <ReactTable
            defaultPageSize={10}
            getTdProps={() => ({
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }
            })}
            data={
              data
                ? data.orders.filter(order => order.status === "PROCESSING")
                : []
            }
            columns={[...fieldsDefinition(props)]}
            showPagination={true}
          />
        </CardBody>
      </Card>
    </>
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default compose(
  withBreadcrumb,
  withModal
)(OrderAuditClListContainer)
